export default __webpack_public_path__ + "static/media/add-schedulle-disabled.ce4e1570.svg";